import { FaAmbulance, FaHandsHelping, FaShieldAlt } from "react-icons/fa";
import { FaUserDoctor } from "react-icons/fa6";

export const aboutData = {
  banner: "/assets/images/about-banner.webp",
  title: "Statistical Expertise for Your Medical Research Path",
  subtitle:
    "We provide clear, accurate, and reliable statistical services tailored for the medical and healthcare fields.",
  points: [
    {
      name: "Qualified Doctors",
      value:
        "Our team includes experts with 10+ years in medical statistics, supervised by a medical faculty member specialized in Biostatistics & Medical Research.",
    },
    {
      name: "Trust & Reliability",
      value:
        "Over 3000 clients have trusted us for precise and professional medical statistical analysis.",
    },
    {
      name: "Strong Support",
      value:
        "Easy and direct communication via phone or Zoom to track every step of your analysis.",
    },
    {
      name: "Accurate & Fast Results",
      value:
        "We offer reliable statistical analysis with detailed result interpretation — delivered quickly and clearly.",
    },
  ],
  advantages: [
    {
      icon: FaUserDoctor,
      value: "Qualified Doctors",
    },
    {
      icon: FaShieldAlt,
      value: "Trust & Reliability",
    },
    {
      icon: FaAmbulance,
      value: "Fast Delivery",
    },
    {
      icon: FaHandsHelping,
      value: "Strong Support",
    },
  ],
};
